import { Component } from "react";
import { Switch, Route, Redirect } from 'react-router-dom';

import AssignmentAdd from "../component/features/assignments/AssignmentAdd";
import AssignmentView from "../component/features/assignments/AssignmentView";
import AssignmentAnalysis from "../component/features/assignments/AssignmentAnalysis";
import AssignmentList from "../component/features/assignments/AssignmentList";

export class AssignmentRouter extends Component {
    
    render() {
        return (
            <Switch>
                <Route exact path="/assignments" component={AssignmentList} />
                <Route exact path="/assignments/create" component={AssignmentAdd} />
                <Route exact path="/assignments/assignment-view/:assignmentId" component={AssignmentView} />
                <Route exact path="/assignments/submit-analysis/:assignmentId" component={AssignmentAnalysis} />
                <Redirect to="/not-found" />
            </Switch>
        )
    }
};